export const getTranslatedLocaleNames = (
  targetLocale: string,
  locales: string[],
): string[] => {
  try {
    const displayNames = new Intl.DisplayNames([targetLocale], {
      type: 'language',
    });

    return locales.map((locale) => displayNames.of(locale) ?? locale);
  } catch (error) {
    // eslint-disable-next-line no-warning-comments
    // TODO: this is a temporary solution to add more context to ICU errors
    throw new Error(
      `ICU Error in getTranslatedLocaleNames: Failed to create Intl.DisplayNames for locale "${targetLocale}". ` +
        `Original error: ${error instanceof Error ? error.message : 'Unknown error'}`,
    );
  }
};
